import React from "react";
import {
  Table, TableCell,
  TableContainer,
  TableHead,
  TableRow, TableBody
} from "@mui/material";

type ColumnConfig = {
  field: string;
  headerName: string;
  align?: "left" | "right" | "center";
};

type TableConfig = {
  title: string;
  columns: ColumnConfig[];
  rows: Record<string, string | number | null>[];
};

const LeveragesTable: React.FC<{ config: any }> = ({ config }) => {
  const colWidth = `${100 / config.column.length}%`;

  return (
    <TableContainer sx={{
      border: "1px solid #C3C3C3",
      borderRadius: "4px",
      padding: 4
    }}>
      <Table size="small">
        <TableHead sx={{ background: "#FBFDFF", padding: "8px" }}>
          <TableRow>
            {config?.column?.map((col: any, idx: number) => (
              <TableCell
                key={col.field}
                align={col.field === "label" ? (col.align ?? "right") : "center"}
                sx={{
                  color: "#32325D",
                  fontFamily: "Open Sans",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "18px",
                  padding: "8px",
                  width: colWidth,
                }}
              >
                {col.headerName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {config?.rows?.map((row: any, idx: number) => (
            <TableRow key={idx}>
              {config?.column?.map((col: any, index: number) => (
                <TableCell key={col.field} align={col.field === "label" ? col.align : "center"} sx={index === 0 ? {
                  borderRadius: "0 0 0 4px",
                  "borderRight": "1px solid #D8D8D8",
                  background: "#FBFDFF",
                  color: "#32325D",
                  textAlign: "right",
                  fontFamily: "Open Sans",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "18px",
                  padding: "8px",
                  width: colWidth,
                  borderBottom: "none"
                } : {
                  color: "#32325D",
                  textAlign: "center",
                  fontFamily: "Open Sans",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 600,
                  lineHeight: "22px",
                  width: colWidth,
                  padding: "8px",
                  borderBottom: "none"
                }}>
                  {row[col.field] ?? "N/A "}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default function KeyMetricsTable(props: any) {
  const { tableConfig, rows } = props;
  return <LeveragesTable config={{ column: tableConfig, rows }} />;
}
